import React, { useState } from 'react';
import KpiCounter from '@/components/KpiCounter';
import { PRODUCTION_RESULTS } from '@/data/results';

export default function ResultsSection() {
  const [activeId, setActiveId] = useState(PRODUCTION_RESULTS[0].id);
  const r = PRODUCTION_RESULTS.find((x) => x.id === activeId);

  return (
    <section id="results" className="bg-[#0B0B0B] border-t border-white/10 py-16 lg:py-24">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <p className="text-[10px] uppercase tracking-[0.2em] text-[#3B82F6]">Production Results</p>
        <h2 className="mt-4 font-display font-bold text-white text-3xl lg:text-[2.75rem] tracking-tight leading-tight max-w-3xl">
          The impact behind the imagery.
        </h2>

        <div className="mt-10 grid lg:grid-cols-[320px_1fr] gap-6">
          <div className="flex lg:flex-col gap-3 overflow-x-auto">
            {PRODUCTION_RESULTS.map((x) => (
              <button
                key={x.id}
                type="button"
                onClick={() => setActiveId(x.id)}
                className={`shrink-0 text-left rounded-xl border p-5 transition-colors ${
                  x.id === activeId ? 'border-[#3B82F6] bg-[#2563EB]/10' : 'border-white/10 hover:border-white/30'
                }`}
              >
                <p className="text-[10px] uppercase tracking-[0.16em] text-[#3B82F6]">{x.sector}</p>
                <p className="mt-1.5 font-display font-semibold text-white">{x.client}</p>
              </button>
            ))}
          </div>

          <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-7 lg:p-10">
            <h3 className="font-display font-bold text-white text-2xl lg:text-3xl tracking-tight">{r.headline}</h3>
            <p className="mt-4 text-white/55 font-light leading-relaxed max-w-2xl">{r.summary}</p>
            <div key={r.id} className="mt-10 grid sm:grid-cols-3 gap-px bg-white/10 rounded-lg overflow-hidden">
              {r.kpis.map((k) => (
                <div key={k.label} className="bg-[#0B0B0B] p-6">
                  <div className="text-4xl lg:text-5xl text-white"><KpiCounter {...k} /></div>
                  <p className="mt-3 text-[11px] uppercase tracking-[0.16em] text-white/45">{k.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}